import { render, staticRenderFns } from "./bulma_camera.vue?vue&type=template&id=03b5048d"
import script from "./bulma_camera.vue?vue&type=script&lang=js"
export * from "./bulma_camera.vue?vue&type=script&lang=js"
import style0 from "./bulma_camera.vue?vue&type=style&index=0&id=03b5048d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports